<template>
  <div>
    <Loader v-if="loader==true" />
    <Scroller v-if="wind.width>560" />
    <!-- 1 -->
    <section id="section1">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="logo d-flex py-5">
              <img src="../assets/logo.png" alt="TrioMarkets Logo" />
            </div>
          </div>
        </div>
        <div class="row d-flex align-items-center pt-5">
          <div class="col-lg-8 col-12 pr-5">
            <div class="hero d-flex align-items-left flex-column">
              <div class="hero-head">
                <h1 class="fw200">
                  One of The
                  <br />
                  <span class="bold">
                    Best ECN
                    <br />Brokers
                  </span>
                </h1>
              </div>
              <p class="py-1">
                At
                <span class="bold">TrioMarkets</span>
                <br />we provide a wide
                <br />range of
                <span class="bold">CFDs</span> on
                <span class="bold">
                  FX,
                  <br />Indices, Commodities
                </span> &amp;
                <br />
                <span class="bold">Precious Metals</span>
              </p>
              <div class="buttonset">
                <button @click="startForm()" class="btn">Open your ECN Account</button>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-12">
            <Form ref="form" :class="'form-wrapper animated '+formAnimation" id="regForm" />
          </div>
        </div>
      </div>
    </section>
    <!-- 2 -->
    <section id="section2" class="d-flex align-items-center justify-content-center">
      <div class="s2heading">
        <h2 class="bold">Features of an ECN Account</h2>
      </div>
      <div class="container text-center">
        <div class="row">
          <!-- 2.1 -->
          <div class="col-md-4">
            <img src="/img/s2i1.png" alt="board" class="pt-5" />
            <p>
              All trading
              <br />strategies allowed
            </p>
          </div>
          <!-- 2.2 -->
          <div class="col-md-4">
            <img src="/img/s2i4.png" alt="bubble" class="emphasize pb-4" />
            <p>
              Forex Liquidity Aggregation
              <br />All orders are routed directly to
              <br />our best liquidity provider, for the
              <br />Lowest available Opening &
              <br />Closing prices at all times
            </p>
          </div>
          <!-- 2.3 -->
          <div class="col-md-4">
            <img src="/img/s2i3.png" alt="bubble" class="pt-5" id="s2e3" />
            <p>
              Use Your Own Expert Advisor
              <br />(EA) with TrioMarkets
            </p>
          </div>
        </div>
        <div class="row">
          <!-- 2.4 -->
          <div class="col-md-4 offset-md-2">
            <img src="/img/s2i2.png" alt="clock" />
            <p>
              We Ensure
              <br />Ultra Fast Execution
            </p>
          </div>
          <!-- 2.5 -->
          <div class="col-md-4">
            <img src="/img/s2i5.png" alt="bubble" />
            <p>
              Competitive Tight Spreads as low
              <br />as 0.0 pips. Minimise Your Costs
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button
              v-scroll-to="{el: '#regForm', easing: 'linear', offset: -200}"
              @click="shakeForm()"
              class="btn"
            >Open your ECN account</button>
          </div>
        </div>
      </div>
    </section>
    <!-- 3 -->
    <section id="section3">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 sq" id="sq1">
            <div class="s3-content text-right">
              <h3 class="fw200">
                Trade Now during market news.
                <br />No more trading restrictions
              </h3>
              <div class="buttonset pt-3">
                <button
                  v-scroll-to="{el: '#regForm', easing: 'linear', offset: -200}"
                  @click="shakeForm()"
                  class="btn"
                >Open your ECN account</button>
              </div>
            </div>
          </div>
          <div class="col-md-6 sq" id="sq2">
            <div class="s3-content text-left">
              <h3 class="fw200">
                Trade Now during market news.
                <br />No more trading restrictions
              </h3>
              <div class="buttonset pt-3">
                <button
                  v-scroll-to="{el: '#regForm', easing: 'linear', offset: -200}"
                  @click="shakeForm()"
                  class="btn"
                >Open your ECN account</button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 sq" id="sq3">
            <div class="s3-content text-right">
              <h3 class="fw200">
                Trade Now during market news.
                <br />No more trading restrictions
              </h3>
              <div class="buttonset pt-3">
                <button
                  v-scroll-to="{el: '#regForm', easing: 'linear', offset: -200}"
                  @click="shakeForm()"
                  class="btn"
                >Open your ECN account</button>
              </div>
            </div>
          </div>
          <div class="col-md-6 sq" id="sq4">
            <div class="s3-content text-left">
              <h3 class="fw200">
                Trade Now during market news.
                <br />No more trading restrictions
              </h3>
              <div class="buttonset pt-3">
                <button
                  v-scroll-to="{el: '#regForm', easing: 'linear', offset: -200}"
                  @click="shakeForm()"
                  class="btn"
                >Open your ECN account</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 4 -->
    <section id="section4" class="d-flex align-items-center justify-content-center">
      <div class="s4heading">
        <h2 class="bold">How to trade CFDs</h2>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-4" id="s4item1">
            <img src="/img/1.png" alt="1" class="s4-img" />
            <p class="text-center">
              Fill in our simplified
              <br />application form about
              <br />your trading experience
            </p>
          </div>
          <div class="col-md-4" id="s4item2">
            <img src="/img/2.png" alt="2" class="s4-img" />
            <p class="text-center">
              Fund your live account or
              <br />practice on a risk-free
              <br />demo account
            </p>
          </div>
          <div class="col-md-4" id="s4item3">
            <img src="/img/3.png" alt="3" class="s4-img" />
            <p class="text-center">
              Discover CFD
              <br />trading
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center pt-5">
            <button
              v-scroll-to="{el: '#regForm', easing: 'linear', offset: -200}"
              @click="shakeForm()"
              class="btn"
            >Open your ECN account</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// function noScroll() {
//   window.scrollTo(0, 0);
// }
// window.addEventListener('scroll', noScroll);
export default {
  name: "home",
  data() {
    return {
      loader: true,
      formAnimation: "zoomInLeft",
      formPopup: false,
      wind: {
        width: window.innerWidth,
        height: window.innerHeight,
        currentPosition: window.pageYOffset
      }
    };
  },
  beforeCreate() {
    this.loader = true;
  },
  mounted() {
    setTimeout(() => {
      this.loader = false;
    }, 500);
  },
  methods: {
    startForm() {
      this.$refs.form.startForm();
    },
    shakeForm() {
      let vm = this;
      setTimeout(() => {
        vm.formAnimation = "tada";
        vm.startForm();
        setTimeout(() => {
          vm.formAnimation = "";
        }, 1000);
      }, 500);
    },
    mobileForm() {
      this.formPopup = true;
    }
  }
};
</script>

<style scoped lang="scss">
</style>
